<template>
  <CRow>
    <CCol col="12" xl="12">
      <transition name="slide">
      <CCard>
        <CCardBody>
            <div class="row mb-3 mr-0 pr-0 d-flex justify-content-end">
              <div class="col-auto pr-0">
                <CButton v-if="permissions.drivers.add" color="success" @click="createDriver()">
                  <CIcon :content="$options.addIcon" /> {{ $t('button.create') }} {{ $tc('drivers.label', 1) }}
                </CButton>
              </div>
            </div>
            <CDataTable
              :items="filteredItems"
              :fields="fields"
              :items-per-page="perPage"
              :itemsPerPageSelect="itemsPerPage"
              :tableFilter="tableFilter"
              :table-filter-value.sync="search"
              :loading="loading"
              addTableClasses="d-print-table table-dropdown-fix"
              hover
              sorter
              pagination
            >
              <template #options="{item}">
                <td>
                  <div class="dropdown">
                    <button class="btn btn-secondary dropdown-toggle" @click="openOptions" type="button" data-toggle="dropdown">
                      {{ $t('button.options') }}
                    </button>
                    <div class="dropdown-menu">
                      <button v-if="permissions.drivers.read" class="dropdown-item" type="button" @click="showDriver(item.id)">{{ $t('button.details') }}</button>
                      <button v-if="permissions.drivers.edit" class="dropdown-item" type="button" @click="editDriver(item.id)">{{ $t('button.edit') }}</button>
                      <button v-if="permissions.drivers.delete" class="dropdown-item" type="button" @click="deleteDriver(item.id)">{{ $t('button.delete') }}</button>
                    </div>
                  </div>
                </td>
              </template>
            </CDataTable>
        </CCardBody>  
      </CCard>
      </transition>
    </CCol>
  </CRow>
</template>

<script>
import { mapState } from 'vuex';
import axios from 'axios';
import listMixin from '../../mixins/list';
import localeMixin from '../../mixins/locale'; // Order matters, mixin first then i18n.
import i18n from "../../i18n";
import { cilPlus } from '@coreui/icons';

export default {
  name: 'Drivers',
  mixins: [listMixin, localeMixin],
  addIcon: cilPlus,
  data() {
    return {
      items: [],
      fields: [
        {
          key: 'name',
          label: i18n.t('fields.name')
        }, 
        {
          key: 'options',
          label: i18n.t('button.options'),
          sorter: false,
          filter: false
        }
      ],
      tableFilter: {
        label: "Buscar:",
        placeholder: "Por nombre",
        lazy: false,
        external: true
      },
    }
  },
  computed: {
    ...mapState({
      permissions: state => state.permissions,
    }),
    filteredItems() {
      // return this.items.filter(i => {
      //   return i.name.toLowerCase().includes(this.search.toLowerCase()) || 
      //   i.phone.includes(this.search.toLowerCase() ||
      //   i.phone2.includes(this.search.toLowerCase()));
      // });
      return this.items.filter(i => {
        return i.name.toLowerCase().includes(this.search.toLowerCase());
      });
    }
  },
  methods: {
      showAlertError() {
          if (this.message != "") {
              this.$swal({
                  title: i18n.t('modal.title'),
                  text: this.message,
                  icon: 'warning',
                  showCancelButton: true,
                  cancelButtonColor: '#d33',
              });
          } else {
              this.$swal({
                  title: i18n.t('modal.title'),
                  text: i18n.t('modal.body'),
                  icon: 'warning',
                  showCancelButton: true,
                  cancelButtonColor: '#d33',
              });
          }
      },
    showDriver(id) {
      this.$router.push({ name: 'Driver', params: {id} });
    },
    editDriver(id) {
      this.$router.push({ name: 'EditDriver', params: {id} });
    },
    deleteDriver(id) {
        let self = this;
      this.$swal({
        title: i18n.t('drivers.modal.delete_label'),
        html: i18n.t('drivers.modal.delete_body'),
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: i18n.t('button.accept')
      }).then(result => {
        if (result.value) {
          // do delete request
          axios.delete('/api/drivers/'+ id + '?token=' + localStorage.getItem("api_token"))
          .then(response => {
              self.getDrivers();
                self.$swal(
                  i18n.t('drivers.modal.updated_label'),
                  i18n.t('drivers.modal.updated_body'),
                  'success'
              );
          });
        }
      });

    },
    createDriver () {
      this.$router.push({ name: 'CreateDriver' });
    },
    showAlert () {
      this.dismissCountDown = this.dismissSecs
    },
    getDrivers () {
      this.loading = true;
      axios.get('/api/drivers?token=' + localStorage.getItem("api_token"))
      .then(response => {
        this.items = response.data;
        this.items.forEach(elem => {
          elem.status_class = elem.active ? "primary" : "secondary";
        });
        this.loading = false;
      }).catch(error => {
        this.loading = false;
        console.log(error);
        this.showAlertError();
      });
    }
  },
  mounted() {
    this.getDrivers();
  }
}
</script>
